"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MentionInputElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _plateMention = require("@udecode/plate-mention");
var _inlineCombobox = require("./inline-combobox");
var _mentionContext = require("../lib/mentionContext");
var _jsxRuntime = require("react/jsx-runtime");
var onSelectItem = (0, _plateMention.getMentionOnSelectItem)();
var MentionInputElement = exports.MentionInputElement = (0, _cn.withRef)(function (_ref, ref) {
  var _ref2;
  var className = _ref.className,
    props = _objectWithoutProperties(_ref, ["className"]);
  var children = props.children,
    editor = props.editor,
    element = props.element;
  var _ref3 = (0, _react.useState)(''),
    _ref4 = _slicedToArray(_ref3, 2),
    search = _ref4[0],
    setSearch = _ref4[1];
  var _ref5 = (0, _mentionContext.useMentionContext)(),
    peopleMentions = _ref5.peopleMentions,
    labelMentions = _ref5.labelMentions;
  var mentionables = element.trigger === '#' ? labelMentions : peopleMentions;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_plateCommon.PlateElement, _objectSpread({
    ref: ref,
    as: "span",
    "data-slate-value": element.value
  }, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_inlineCombobox.InlineCombobox, {
      value: search,
      element: element,
      setValue: setSearch,
      showTrigger: true,
      trigger: (_ref2 = element.trigger) !== null && _ref2 !== void 0 ? _ref2 : '@',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: (0, _cn.cn)('inline-block rounded-md bg-muted px-1.5 py-0.5 align-baseline text-sm ring-ring focus-within:ring-2', className),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_inlineCombobox.InlineComboboxInput, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_inlineCombobox.InlineComboboxContent, {
        className: "my-1.5",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_inlineCombobox.InlineComboboxEmpty, {
          children: "No results found"
        }), mentionables.map(function (item) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_inlineCombobox.InlineComboboxItem, {
            value: item.text,
            onClick: function onClick() {
              return onSelectItem(editor, item, search);
            },
            children: item.text
          }, item.key);
        })]
      })]
    }), children]
  }));
});